import React from 'react'
import Layout from './Layout';
import ApartmentSignUpForm from './ApartmentSignUpForm';
import ApartmentSmallScreen from './ApartmentSmallScreen';
import useResponsive from '../../shared/utils/Responsive';

const ApartmentSignUp= () => {
    const isSmallScreen = useResponsive("md")

    return (
        <>
            {
                !isSmallScreen && (
                    <Layout text={"Apartment sign up to explore activities and courses in your community."} firstSize={6} secondSize={6}>
                        <ApartmentSignUpForm />
                    </Layout>
                )}
            {
                isSmallScreen && <ApartmentSmallScreen tabPage={1} />
            }
        </>

    )
}

export default ApartmentSignUp

